module.exports = __webpack_public_path__ + "static/media/mh_entrium_04.5fed9e3a.png";